<template>
    <div class="h-form-wrapper">
        <div class="h-form-box">
            <div class="ft-box">
                <div class="ft-title aFlex">
                    <Icon class="ft-title-mark" type="md-bookmark" />
                    <span>忘记密码</span>
                </div>
            </div>
            <Form class="form-list" ref="formInline" :model="formInline" :rules="ruleInline" inline :label-width="150" label-position="right">
                <Row>
                    <Col span="12" offset="4">
                        <FormItem label="用户类型" prop="userType">
                            <RadioGroup v-model="formInline.userType">
                                <template v-for="(item,index) in common.userTypes">
                                    <Radio :label="item.value" v-if="index>0">{{item.label}}</Radio>
                                </template>
                            </RadioGroup>
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="12" offset="4">
                        <FormItem label="登录用户名" prop="account">
                            <Input v-model="formInline.account" @on-blur="handleAccount"
                                   size="large" placeholder="请输入统一社会信用代码/手机号码"></Input>
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="12" offset="4">
                        <FormItem label="*注册手机号" prop="linkPersonTel">
                            <div>
                                <span>{{formInline.mobile.slice(0,3)+'****'+formInline.mobile.slice(7)}}</span>
                                <span>（注：根据用户类型、用户名自动匹配注册手机号）</span>
                            </div>
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="12" offset="4">
                        <FormItem label="新密码" prop="password">
                            <Input type="password" v-model="formInline.password" size="large" placeholder="请输入新密码"></Input>
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="12" offset="4">
                        <FormItem label="确认密码" prop="passwdCheck">
                            <Input type="password" v-model="formInline.passwdCheck" size="large" placeholder="请输入确认密码"></Input>
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="12" offset="4">
                        <FormItem label="短信验证码" prop="verifyNumber">
                            <div class="aFlex">
                                <Input v-model="formInline.verifyNumber" size="large" placeholder="请输入短信验证码"></Input>
                                <Button style="margin-left: 15px" type="primary" size="large"
                                        :disabled="timeing" @click="handleVerify">{{verifyTxt}}</Button>
                            </div>
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="12" offset="4">
                        <FormItem>
                            <Button class="h-form-btn" type="primary" size="large" @click="handleSubmit('formInline')" :loading="loading">提交</Button>
                            <Button class="h-form-btn" size="large" @click="handleBack">返回</Button>
                        </FormItem>
                    </Col>
                </Row>
            </Form>
        </div>
    </div>
</template>
<style scoped>

</style>
<script>
    export default {
        data(){
            const validatePass = (rule, value, callback) => {
                let reg=/^.{6,18}$/;
                if (value === '') {
                    callback(new Error('请输入密码!'));
                } else {
                    if(reg.test(value)){
                        if (this.formInline.passwdCheck !== '') {
                            // 对第二个密码框单独验证
                            this.$refs.formInline.validateField('passwdCheck');
                        }
                        callback();
                    }else {
                        callback('密码必须6-18位');
                    }
                }
            };
            const validatePassCheck = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入确认密码!'));
                } else if (value !== this.formInline.password) {
                    callback(new Error('两次密码输入不一致!'));
                } else {
                    callback();
                }
            };
            return {
                verifyTxt: '获取验证码',
                timeing: false,
                num:60,
                timeout:null,
                loading: false,
                formInline: {
                    userType: '',
                    account: '',
                    mobile: '',
                    password: '',
                    passwdCheck: '',
                    verifyNumber: '',
                    verifyCode: '',
                },
                ruleInline: {
                    userType: [
                        { required: true, message: '用户类型不能为空', trigger: 'change' },
                    ],
                    account: [
                        { required: true, message: '用户名不能为空', trigger: 'blur' },
                    ],
                    password: [
                        { required: true,validator: validatePass, trigger: 'blur' }
                    ],
                    passwdCheck: [
                        { required: true, validator: validatePassCheck, trigger: 'blur' }
                    ],
                    verifyNumber: [
                        { required: true, type:'string',  message: '短信验证码不正确', trigger: 'submit' }
                    ],
                },
            };
        },
        computed:{

        },
        created(){
            this.formInline.userType=this.$route.query.loginType;
        },
        mounted(){

        },
        watch: {

        },
        methods: {
            // 获取用户手机号
            handleAccount(){
                if(!this.formInline.account){
                    return;
                }
                this.axios({
                    method: 'get',
                    url: '/register/autoMatchMobile',
                    params: {
                        account: this.formInline.account
                    },
                }).then((response) => {
                    if(response.data){
                        this.formInline.mobile = response.data.data;
                        if(!response.data.data){
                            this.$Message.warning('当前用户不存在!');
                        }
                    }
                });
            },
            // 获取验证码
            handleVerify() {
                if(!/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.formInline.mobile)){
                    this.$Message.warning('手机号不正确');
                    return;
                }
                this.axios({
                    method: 'get',
                    url: '/register/getVerifyNumber',
                    params: {
                        mobile: this.formInline.mobile
                    },
                }).then((response) => {
                    if(response.data){
                        this.formInline.verifyCode = response.data;
                        this.timeing=true;
                        this.setTime();
                    }
                });
            },
            setTime(){
                if(this.num>0){
                    this.num--;
                    this.verifyTxt = '获取验证码( ' + this.num + ' )'
                }else{
                    clearTimeout(this.timeout);
                    this.num=60;
                    this.timeing=false;
                    this.verifyTxt = '重新获取';
                    return;
                }
                this.timeout=setTimeout(this.setTime,1000);
            },
            // 返回
            handleBack(){
                this.$router.go(-1);
            },
            // 提交
            handleSubmit(name){
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        let data={};
                        Object.assign(data,this.formInline);
                        delete data.passwdCheck;
                        this.loading=true;
                        this.axios({
                            method: 'post',
                            url: '/register/updatePwd',
                            data: data,
                        }).then((response) => {
                            this.loading=false;
                            if(response.data.success){
                                this.$Modal.success({
                                    title: '提示',
                                    content: '修改密码成功!',
                                    onOk:()=>{
                                        this.$router.go(-1);
                                    }
                                });
                            }else {
                                this.$Modal.warning({
                                    title: '提示',
                                    content: response.data.msg
                                });
                            }
                        }).catch( ()=> {
                            this.loading=false;
                        });
                    } else {
                        this.$Message.error('表单验证未通过!');
                    }
                });
            }
        }
    };
</script>
